export default __webpack_public_path__ + "static/media/feature_1.801589a0.png";